export enum Environment {
  PRODUCTION = 'production',
  UFT = 'uft',
  DEVELOPMENT = 'development'
}

export interface IPlatformSpecific {
  SHOW_CITIES_ON_BOOKING: boolean
  SHOW_EMAIL_CONSENT: boolean
  SHOW_SMS_CONSENT: boolean
}

export interface IConfiguration {
  UFO_APP_PLATFORM: string
  UFO_APP_BUILD_TYPE: 'debug' | 'staging' | 'release'
  UFO_APP_ENVIRONMENT: Environment
  UFO_APP_NAME: string
  UFO_APP_VERSION: string
  UFO_APP_BUILD_NUMBER: string
  UFO_PLATFORM_DOMAIN: string
  UFO_SERVER_API_URL: string
  UFO_SERVER_GRAPHQL_URL: string
  UFO_ANALYTICS_ACTIVE: boolean
  UFO_ANALYTICS_API_URL: string
  UFO_ANALYTICS_API_KEY: string
  GOOGLE_MAP_API_KEY: string
  FIREBASE_CONFIG: any
  WEBSITE_URL: string
  UFO_MESSAGE?: { title: string; body: string }
  PLATFORM_SPECIFICS: IPlatformSpecific
  UFO_RESOURCES: string
  setConfigs: (configs: Partial<IPlatformSpecific>) => void
  getRessource: (url: string) => string | undefined
}

class Configuration implements IConfiguration {
  UFO_APP_BUILD_TYPE!: 'debug' | 'staging' | 'release'

  UFO_APP_PLATFORM!: string

  UFO_APP_PLATFORM_NAME!: string

  UFO_APP_ENVIRONMENT!: Environment

  UFO_APP_NAME!: string

  UFO_APP_VERSION!: string

  UFO_APP_BUILD_NUMBER!: string

  UFO_PLATFORM_DOMAIN!: string

  UFO_SERVER_API_URL!: string

  UFO_SERVER_GRAPHQL_URL!: string

  UFO_ANALYTICS_ACTIVE!: boolean

  UFO_ANALYTICS_API_URL!: string

  UFO_ANALYTICS_API_KEY!: string

  UFO_PAYMENT_API_KEY!: string

  GOOGLE_MAP_API_KEY = 'AIzaSyB5HitiuRYbhLlraBOW5id9O4NBmx6rcYk'

  FIREBASE_CONFIG!: any

  UFO_SERVER_PRIVATE_API_URL!: string

  UFO_SERVER_PUBLIC_API_URL!: string

  WEBSITE_URL!: string

  UFO_MESSAGE?: { title: string; body: string }

  PLATFORM_SPECIFICS!: IPlatformSpecific

  IOS_APP_LINK!: string

  ANDROID_APP_LINK!: string

  UFO_RESOURCES!: string

  setConfigs = (configs: any) => {
    this.PLATFORM_SPECIFICS = {
      ...this.PLATFORM_SPECIFICS,
      ...configs.PLATFORM_SPECIFICS
    }
  }

  getRessource = (url?: string | null) => {
    if (!url || url.trim().length === 0) {
      return undefined
    }

    if (/^(https?:\/\/|data:|file:)/.test(url)) {
      return url
    }

    if (url.startsWith && url.startsWith('/')) {
      return `${this.UFO_RESOURCES}${url}`
    }

    return `${this.UFO_RESOURCES}/${url}`
  }

  // eslint-disable-next-line complexity
  constructor() {
    switch (process.env.REACT_APP_BUILD_TYPE) {
      case 'debug':
        this.UFO_APP_BUILD_TYPE = 'debug'
        break
      case 'staging':
        this.UFO_APP_BUILD_TYPE = 'staging'
        break
      case 'release':
        this.UFO_APP_BUILD_TYPE = 'release'
        break
      default:
        throw new Error('process.env.REACT_APP_PLATFORM is required')
    }

    switch (process.env.REACT_APP_PLATFORM) {
      case 'uft':
        this.UFO_APP_PLATFORM = 'uft'
        this.UFO_APP_PLATFORM_NAME = 'uft'
        this.UFO_PLATFORM_DOMAIN = 'uft.ufodrive.com'
        this.WEBSITE_URL = 'https://ufodrive.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyCRa-Uw2Fz5wrWer8YcezDRMzrk4LRKGFk',
          authDomain: 'ufodrive-uft.firebaseapp.com',
          projectId: 'ufodrive-uft',
          storageBucket: 'ufodrive-uft.appspot.com',
          messagingSenderId: '368549205944',
          appId: '1:368549205944:web:b0e806d63b5cd05956614d',
          measurementId: 'G-7GKFSFY6SG'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: true, SHOW_EMAIL_CONSENT: true, SHOW_SMS_CONSENT: true }
        this.IOS_APP_LINK =
          'https://itunes.apple.com/us/app/ufodrive/id1361755810'
        this.ANDROID_APP_LINK =
          'https://play.google.com/store/apps/details?id=com.ufodrive.app'
        this.UFO_RESOURCES = 'https://resources.uft.ufodrive.com'
        break
      case 'ufodrive':
        this.UFO_APP_PLATFORM = 'ufodrive'
        this.UFO_APP_PLATFORM_NAME = 'ufodrive'
        this.UFO_PLATFORM_DOMAIN = 'ufodrive.com'
        this.WEBSITE_URL = 'https://ufodrive.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyA-dACCTv2zgguGrNpkbq0pGTYgQoMQ4Q8',
          authDomain: 'ufodrive-215814.firebaseapp.com',
          databaseURL: 'https://ufodrive-215814.firebaseio.com',
          projectId: 'ufodrive-215814',
          storageBucket: 'ufodrive-215814.appspot.com',
          messagingSenderId: '460958527990',
          appId: '1:460958527990:web:ef406366175d4c132857d7',
          measurementId: 'G-PK0BNW3503'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: true, SHOW_EMAIL_CONSENT: true, SHOW_SMS_CONSENT: true }
        this.IOS_APP_LINK =
          'https://itunes.apple.com/us/app/ufodrive/id1361755810'
        this.ANDROID_APP_LINK =
          'https://play.google.com/store/apps/details?id=com.ufodrive.app'
        this.UFO_RESOURCES = 'https://resources.ufodrive.com'
        break
      case 'demo':
        this.UFO_APP_PLATFORM = 'demo'
        this.UFO_PLATFORM_DOMAIN = 'demo.ufodrive.com'
        this.WEBSITE_URL = 'https://ufodrive.com'
        this.FIREBASE_CONFIG = null
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: true, SHOW_EMAIL_CONSENT: true, SHOW_SMS_CONSENT: true }
        this.IOS_APP_LINK =
          'https://itunes.apple.com/us/app/ufodrive/id1361755810'
        this.ANDROID_APP_LINK =
          'https://play.google.com/store/apps/details?id=com.ufodrive.app'
        this.UFO_RESOURCES = 'https://resources.demo.ufodrive.com'
        break
      case 'template':
        this.UFO_APP_PLATFORM = 'template'
        this.UFO_PLATFORM_DOMAIN = 'template.ufodrive.com'
        this.WEBSITE_URL = 'https://ufodrive.com'
        this.FIREBASE_CONFIG = null
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: true, SHOW_EMAIL_CONSENT: true, SHOW_SMS_CONSENT: true }
        this.IOS_APP_LINK =
          'https://itunes.apple.com/us/app/ufodrive/id1361755810'
        this.ANDROID_APP_LINK =
          'https://play.google.com/store/apps/details?id=com.ufodrive.app'
        this.UFO_RESOURCES = 'https://resources.template.ufodrive.com'
        break
      case 'ppr':
        this.UFO_APP_PLATFORM = 'ppr'
        this.UFO_PLATFORM_DOMAIN = 'ppr.ufodrive.com'
        this.WEBSITE_URL = 'https://ufodrive.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyAmsXjMMoNIvGv_6b0riN3AibzsZDtulrM',
          authDomain: 'ufodrive-ppr.firebaseapp.com',
          projectId: 'ufodrive-ppr',
          storageBucket: 'ufodrive-ppr.appspot.com',
          messagingSenderId: '402805316759',
          appId: '1:402805316759:web:7d087f36164680c2229dd2',
          measurementId: 'G-MDWMMWHP0G'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: true, SHOW_EMAIL_CONSENT: true, SHOW_SMS_CONSENT: true }
        this.IOS_APP_LINK =
          'https://itunes.apple.com/us/app/ufodrive/id1361755810'
        this.ANDROID_APP_LINK =
          'https://play.google.com/store/apps/details?id=com.ufodrive.app'
        this.UFO_RESOURCES = 'https://resources.ppr.ufodrive.com'
        break
      case 'hertz':
        this.UFO_APP_PLATFORM = 'hertz'
        this.UFO_APP_PLATFORM_NAME = 'Hertz'
        this.UFO_PLATFORM_DOMAIN = 'hz-hertz.com'
        this.WEBSITE_URL = 'https://www.hertz.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyBoxIIjhfpvecVjS7dScgVwriN2CUtjie0',
          authDomain: 'hertz-2c898.firebaseapp.com',
          projectId: 'hertz-2c898',
          storageBucket: 'hertz-2c898.appspot.com',
          messagingSenderId: '880496693470',
          appId: '1:880496693470:web:f73f2133ce0b49655fb24f',
          measurementId: 'G-FCSXCNDCTT'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: true, SHOW_SMS_CONSENT: false }

        this.IOS_APP_LINK =
          'https://apps.apple.com/us/app/hertz-hz/id1591663462'
        this.ANDROID_APP_LINK =
          'https://play.google.com/store/apps/details?id=com.hertz.driverApp'
        this.UFO_RESOURCES = 'https://resources.hz-hertz.com'
        break
      case 'hertz247ie':
        this.UFO_APP_PLATFORM = 'hertz247ie'
        this.UFO_APP_PLATFORM_NAME = 'Hertz Ireland'
        this.UFO_PLATFORM_DOMAIN = 'hertz247.ie'
        this.WEBSITE_URL = 'https://www.hertz247.ie'
        this.FIREBASE_CONFIG = null
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: false, SHOW_SMS_CONSENT: false }
        this.IOS_APP_LINK = 'https://apps.apple.com/us/app/hertz-24-7-ie/id6471581079'
        this.ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.hertz247ie.driverApp'
        this.UFO_RESOURCES = 'https://resources.hertz247.ie'
        break
      case 'hertzch':
        this.UFO_APP_PLATFORM = 'hertzch'
        this.UFO_APP_PLATFORM_NAME = 'Hertz CH'
        this.UFO_PLATFORM_DOMAIN = 'hertzch.ufofleet.com'
        this.WEBSITE_URL = 'https://www.hertz.ch'
        this.FIREBASE_CONFIG = null
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: false, SHOW_SMS_CONSENT: false }
        this.IOS_APP_LINK = 'https://apps.apple.com/us/app/hertz-24-7-ch/id6475427883'
        this.ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.hertz247ch.driverApp'
        this.UFO_RESOURCES = 'https://resources.hertzch.ufofleet.com'
        break
      case 'hertz247':
        this.UFO_APP_PLATFORM = 'hertz247'
        this.UFO_APP_PLATFORM_NAME = 'Hertz 24/7'
        this.UFO_PLATFORM_DOMAIN = 'hertz247.ufofleet.com'
        this.WEBSITE_URL = 'https://www.hertz247.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyAwmwic4nINu-0QZXP9uoNlstJcmY7oSvc',
          authDomain: 'hertz247-9dc44.firebaseapp.com',
          projectId: 'hertz247-9dc44',
          storageBucket: 'hertz247-9dc44.appspot.com',
          messagingSenderId: '46127968152',
          appId: '1:46127968152:web:477b1619bbde7a2978c5ed'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: false, SHOW_SMS_CONSENT: false }
        this.IOS_APP_LINK = 'https://apps.apple.com/us/app/hertz-24-7-mobility-new/id6453605078'
        this.ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.hertz247.driverApp'
        this.UFO_RESOURCES = 'https://resources.hertz247.ufofleet.com'
        break
      case 'merchants':
        this.UFO_APP_PLATFORM = 'merchants'
        this.UFO_APP_PLATFORM_NAME = 'merchants'
        this.UFO_PLATFORM_DOMAIN = 'merchantsfleetshare.com'
        this.WEBSITE_URL = 'https://www.merchants.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyCybMXQGTJ0v64IBrlgny3FhwZfN8r4zYg',
          authDomain: 'merchants-e86ab.firebaseapp.com',
          projectId: 'merchants-e86ab',
          storageBucket: 'merchants-e86ab.appspot.com',
          messagingSenderId: '1089087895971',
          appId: '1:1089087895971:web:f81052e5d5ebb293e38216',
          measurementId: 'G-B4CQLLKSY5'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: false, SHOW_SMS_CONSENT: false }
        this.IOS_APP_LINK =
          'https://apps.apple.com/us/app/merchants-fleetshare/id1660319717'
        this.ANDROID_APP_LINK =
          'https://play.google.com/store/apps/details?id=com.merchantsfleet.driverApp'
        this.UFO_RESOURCES = 'https://resources.merchantsfleetshare.com'
        break

      case 'acldrive':
        this.UFO_APP_PLATFORM = 'acldrive'
        this.UFO_APP_PLATFORM_NAME = 'ACL Drive'
        this.UFO_PLATFORM_DOMAIN = 'acldrive.lu'
        this.WEBSITE_URL = 'https://www.acl.lu'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyAVGnuvuAC-nwl6DP6kAfNogdwSyJ8v22U',
          authDomain: 'acl-lu-192fd.firebaseapp.com',
          projectId: 'acl-lu-192fd',
          storageBucket: 'acl-lu-192fd.appspot.com',
          messagingSenderId: '844377731004',
          appId: '1:844377731004:web:bb8e95a722130b73e085b9',
          measurementId: 'G-87EQKT2NB4'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: false, SHOW_SMS_CONSENT: false }
        this.IOS_APP_LINK =
          'https://apps.apple.com/us/app/acl'
        this.ANDROID_APP_LINK =
          'https://play.google.com/store/apps/details?id=com.acl.driverApp'
        this.UFO_RESOURCES = 'https://resources.acldrive.lu'
        break
      case 'rentacab':
        this.UFO_APP_PLATFORM = 'rentacab'
        this.UFO_APP_PLATFORM_NAME = 'Rentacab'
        this.UFO_PLATFORM_DOMAIN = 'rentacab.nl'
        this.WEBSITE_URL = 'https://www.rentacab.nl'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyAbh_v3oL8L4qCC_LLMGINQvqsRb7fczN0',
          authDomain: 'rentacab-fa943.firebaseapp.com',
          projectId: 'rentacab-fa943',
          storageBucket: 'rentacab-fa943.appspot.com',
          messagingSenderId: '887886575781',
          appId: '1:887886575781:web:13266a57dab7e24190354c',
          measurementId: 'G-V48KXDDG4C'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: false, SHOW_SMS_CONSENT: false }
        this.IOS_APP_LINK = ''
        this.ANDROID_APP_LINK = ''
        this.UFO_RESOURCES = 'https://resources.rentacab.nl'
        break

      case 'outbound':
        this.UFO_APP_PLATFORM = 'outbound'
        this.UFO_APP_PLATFORM_NAME = 'Outbound'
        this.UFO_PLATFORM_DOMAIN = 'getoutbound.io'
        this.WEBSITE_URL = 'https://www.booking.getoutbound.io'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyAlhnVgfLk7NIcRcrRlHtiq1uR88IkzVIw',
          authDomain: 'outbound-542ed.firebaseapp.com',
          projectId: 'outbound-542ed',
          storageBucket: 'outbound-542ed.appspot.com',
          messagingSenderId: '929716190267',
          appId: '1:929716190267:web:52231c8899bb222c05301e',
          measurementId: 'G-8GYNW99D7N'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: false, SHOW_SMS_CONSENT: false }
        this.IOS_APP_LINK = 'https://apps.apple.com/us/app/outbound-electric-mobility/id1672023781'
        this.ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.outbound.driverApp'
        this.UFO_RESOURCES = 'https://resources.getoutbound.io'
        break
      case 'pritchards':
        this.UFO_APP_PLATFORM = 'pritchards'
        this.UFO_APP_PLATFORM_NAME = 'Pritchards'
        this.UFO_PLATFORM_DOMAIN = 'pritchards.com'
        this.WEBSITE_URL = 'https://www.pritchards.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyCDFgUSPmN9cRzNWP99yMR2c_5nB5g5uhw',
          authDomain: 'pritchards-1b056.firebaseapp.com',
          projectId: 'pritchards-1b056',
          storageBucket: 'pritchards-1b056.appspot.com',
          messagingSenderId: '1012775527434',
          appId: '1:1012775527434:web:95d7b71d24beecda21abf3',
          measurementId: 'G-5TKF556FLE'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: false, SHOW_SMS_CONSENT: false }
        this.IOS_APP_LINK = 'https://apps.apple.com/us/app/pritchards-lake-life-rentals/id6445825611'
        this.ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.pritchards.driverApp'
        this.UFO_RESOURCES = 'https://resources.pritchards.com'
        break
      case 'noleggioelettrico':
        this.UFO_APP_PLATFORM = 'noleggioelettrico'
        this.UFO_APP_PLATFORM_NAME = 'noleggioelettrico'
        this.UFO_PLATFORM_DOMAIN = 'noleggioelettrico.ufofleet.com'
        this.WEBSITE_URL = 'https://www.noleggioelettrico.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyCMJ2pbFVutCDVqH3-Cv0Wn1M_-elbaWEE',
          authDomain: 'noleggioelettrico-bbf17.firebaseapp.com',
          projectId: 'noleggioelettrico-bbf17',
          storageBucket: 'noleggioelettrico-bbf17.appspot.com',
          messagingSenderId: '497710510051',
          appId: '1:497710510051:web:263237fd68a4a4949ffad6',
          measurementId: 'G-B7T7QTNK1X'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: false, SHOW_SMS_CONSENT: false }
        this.IOS_APP_LINK = 'https://apps.apple.com/us/app/noleggioelettrico'
        this.ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.noleggioelettrico.driverApp'
        this.UFO_RESOURCES = 'https://resources.noleggioelettrico.ufofleet.com'
        break
      case 'carvo':
        this.UFO_APP_PLATFORM = 'carvo'
        this.UFO_APP_PLATFORM_NAME = 'carvo'
        this.UFO_PLATFORM_DOMAIN = 'carvo.ufofleet.com'
        this.WEBSITE_URL = 'https://www.carvo.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyD4SpYwU4dGpPkyEkrwgMhOyyAYO4Zvts4',
          authDomain: 'carvo-18387.firebaseapp.com',
          projectId: 'carvo-18387',
          storageBucket: 'carvo-18387.appspot.com',
          messagingSenderId: '951470366537',
          appId: '1:951470366537:web:5e2d1da425ad0e1237c498'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: false, SHOW_SMS_CONSENT: false }
        this.IOS_APP_LINK = 'https://apps.apple.com/us/app/carvo'
        this.ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.carvo.driverApp'
        this.UFO_RESOURCES = 'https://resources.carvo.ufofleet.com'
        break
      case 'rdbgroup':
        this.UFO_APP_PLATFORM = 'rdbgroup'
        this.UFO_APP_PLATFORM_NAME = 'rdbgroup'
        this.UFO_PLATFORM_DOMAIN = 'rdbgroup.ufofleet.com'
        this.WEBSITE_URL = 'https://www.rdbgroup.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyAqtptySbs0ng32sUqZBqgZ8FMA0CopRe4',
          authDomain: 'rdbgroup-1fdba.firebaseapp.com',
          projectId: 'rdbgroup-1fdba',
          storageBucket: 'rdbgroup-1fdba.appspot.com',
          messagingSenderId: '97769769796',
          appId: '1:97769769796:web:dbb5eb963ef281bf0ca511',
          measurementId: 'G-VVWBFGLGG7'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: false, SHOW_SMS_CONSENT: false }
        this.IOS_APP_LINK = 'https://apps.apple.com/us/app/rdbgroup'
        this.ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.rdbgroup.driverApp'
        this.UFO_RESOURCES = 'https://resources.rdbgroup.ufofleet.com'
        break
      case 'maximobility':
        this.UFO_APP_PLATFORM = 'maximobility'
        this.UFO_APP_PLATFORM_NAME = 'maximobility'
        this.UFO_PLATFORM_DOMAIN = 'maximobility.ufofleet.com'
        this.WEBSITE_URL = 'https://www.maximobility.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyAKgALdMdb4-qlidUcuvCEhQ6-p0-jpFfU',
          authDomain: 'maximobility-210ea.firebaseapp.com',
          projectId: 'maximobility-210ea',
          storageBucket: 'maximobility-210ea.appspot.com',
          messagingSenderId: '714592294003',
          appId: '1:714592294003:web:f99d87aa3683a2c3d78606'
        } // to do
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: false, SHOW_EMAIL_CONSENT: false, SHOW_SMS_CONSENT: false }
        this.IOS_APP_LINK = 'https://apps.apple.com/us/app/maximobility'
        this.ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.maximobility.driverApp'
        this.UFO_RESOURCES = 'https://resources.maximobility.ufofleet.com'
        break
      case 'stellantis':
        this.UFO_APP_PLATFORM = 'stellantis'
        this.UFO_PLATFORM_DOMAIN = 'stellantis.ufofleet.com'
        this.WEBSITE_URL = 'https://stellantis.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyAmsXjMMoNIvGv_6b0riN3AibzsZDtulrM',
          authDomain: 'ufodrive-ppr.firebaseapp.com',
          projectId: 'ufodrive-ppr',
          storageBucket: 'ufodrive-ppr.appspot.com',
          messagingSenderId: '402805316759',
          appId: '1:402805316759:web:7d087f36164680c2229dd2',
          measurementId: 'G-MDWMMWHP0G'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: true, SHOW_EMAIL_CONSENT: true, SHOW_SMS_CONSENT: true }
        this.IOS_APP_LINK =
          'https://itunes.apple.com/us/app/ufodrive/id1361755810'
        this.ANDROID_APP_LINK =
          'https://play.google.com/store/apps/details?id=com.ufodrive.app'
        this.UFO_RESOURCES = 'https://resources.stellantis.ufofleet.com'
        break
      case 'stellantis-ppr':
        this.UFO_APP_PLATFORM = 'ppr'
        this.UFO_PLATFORM_DOMAIN = 'stellantis-ppr.ufofleet.com'
        this.WEBSITE_URL = 'https://stellantis.com'
        this.FIREBASE_CONFIG = {
          apiKey: 'AIzaSyAmsXjMMoNIvGv_6b0riN3AibzsZDtulrM',
          authDomain: 'ufodrive-ppr.firebaseapp.com',
          projectId: 'ufodrive-ppr',
          storageBucket: 'ufodrive-ppr.appspot.com',
          messagingSenderId: '402805316759',
          appId: '1:402805316759:web:7d087f36164680c2229dd2',
          measurementId: 'G-MDWMMWHP0G'
        }
        this.PLATFORM_SPECIFICS = { SHOW_CITIES_ON_BOOKING: true, SHOW_EMAIL_CONSENT: true, SHOW_SMS_CONSENT: true }
        this.IOS_APP_LINK =
          'https://itunes.apple.com/us/app/ufodrive/id1361755810'
        this.ANDROID_APP_LINK =
          'https://play.google.com/store/apps/details?id=com.ufodrive.app'
        this.UFO_RESOURCES = 'https://resources.stellantis-ppr.ufofleet.com'
        break
      default:
        throw new Error('process.env.REACT_APP_PLATFORM is required')
    }

    this.UFO_APP_NAME = process.env.REACT_APP_NAME || ''
    this.UFO_APP_VERSION = process.env.REACT_APP_VERSION || ''
    this.UFO_APP_BUILD_NUMBER = process.env.UFO_APP_BUILD_NUMBER || '0'
    this.UFO_APP_ENVIRONMENT =
      (process.env.REACT_APP_ENV as Environment) || Environment.PRODUCTION
    this.UFO_SERVER_API_URL = `https://back.${this.UFO_PLATFORM_DOMAIN}/ufodrive/1.0.0/`
    // this.UFO_SERVER_API_URL = 'http://localhost:1337/ufodrive/1.0.0/'
    this.UFO_SERVER_GRAPHQL_URL = `https://back.${this.UFO_PLATFORM_DOMAIN}/graphql`
    this.UFO_SERVER_PRIVATE_API_URL = this.UFO_SERVER_API_URL + 'api/'
    this.UFO_SERVER_PUBLIC_API_URL = this.UFO_SERVER_API_URL + 'public/api/'
    console.log(
      '********************************************************************************************'
    )
    console.info(
      'initialiseEnvironment',
      `APP [${this.UFO_APP_NAME}] BUILD TYPE [${this.UFO_APP_BUILD_TYPE}] for PLATFORM [${this.UFO_APP_PLATFORM}] `
    )
    console.info(
      'initialiseEnvironment',
      `ENV: [${this.UFO_APP_ENVIRONMENT}] WITH BASE API URL [${this.UFO_SERVER_API_URL}] `
    )
    console.info(
      'initialiseEnvironment',
      `VERSION: [${this.UFO_APP_VERSION}] BUILD NUMBER [${this.UFO_APP_BUILD_NUMBER}]`
    )
    console.log(
      '********************************************************************************************'
    )
  }
}

export default new Configuration()
